@if (head) {
  <vw-day-message [message]="head" (act)="onAct($event)" (more)="openReply($event)"></vw-day-message>
}
<!-- La bande météo et lune se pose juste sous le message, avant les autres gestes. -->
<ng-content select="[vwDayBoardBand]"></ng-content>
@if (others.length || willy || fortnight) {
  <!-- Second plan : des lignes de 64 px, la pastille dans la ligne de raison, « … » en cible de 44 px. -->
  <vw-list-section edge="inset" class="mt-2 block" data-test="day-others">
    @for (message of others; track message.key) {
      <!-- Un message qui mène à un écran (« Préparer ma saison ») se lit comme un lien : toute la ligne, un chevron, sa pastille dit où. -->
      <vw-list-row [title]="rowTitle(message)" [interactive]="leadsAway(message)" (rowClick)="onAct(message)"
        [chevron]="leadsAway(message)" [size]="64" [thumb]="message.plants[0]?.imageUrl ? 'bare' : 'tint'" data-test="day-other">
        @if (message.plants[0]?.imageUrl; as image) {
          <img vwListRowIcon [src]="image" alt="" class="vw-plant-thumb" />
        } @else if (message.signal) {
          <span vwListRowIcon class="block h-6 w-6 [&_svg]:h-full [&_svg]:w-full">
            <ng-container *ngComponentOutlet="icons[message.signal.icon]"></ng-container>
          </span>
        }
        @if (message.signal) {
          <vw-tag vwListRowSubtitle [tone]="tagTone(message)" [icon]="message.signal.icon"
            [label]="leadsAway(message) ? ('home.day.button.' + message.button!.key | translate) : (message.tag | vwDayText)"></vw-tag>
        }
        @if (message.rowReason; as reason) {
          <span vwListRowSubtitle>{{ reason | vwDayText }}</span>
        }
        @if (message.estimated) {
          <vw-tag vwListRowSubtitle tone="estimate" [label]="'home.day.estimated' | translate"></vw-tag>
        }
        @if (!leadsAway(message)) {
          <button vwListRowTrailing type="button" (click)="openReply(message)" [attr.aria-label]="'home.day.more' | translate"
            class="-mr-2 flex h-target w-target items-center justify-center rounded-pill text-vw-icon-idle active:bg-vw-surface-sunk">
            <vw-three-dots-icon class="block rotate-90" aria-hidden="true"></vw-three-dots-icon>
          </button>
        }
      </vw-list-row>
    }
    @if (willy; as question) {
      <!-- Un jour calme : ce qu'on peut demander à Willy, tiré des graines. -->
      <vw-list-row [title]="'home.day.willy.quoted' | translate: { text: (question | vwDayText) }" [subtitle]="'home.day.willy.ask' | translate"
        [chevron]="false" [size]="64" thumb="bare" (rowClick)="askWilly(question)" data-test="day-willy">
        <img vwListRowIcon [src]="willyImage" alt="" class="vw-plant-thumb" />
      </vw-list-row>
    }
    @if (fortnight) {
      <vw-list-row [title]="'home.day.fortnight' | translate" tone="link" [dense]="true"
        (rowClick)="openFortnight()" data-test="day-fortnight"></vw-list-row>
    }
  </vw-list-section>
}

<!-- Sans croix : le titre du message garde toute la largeur ; le voile, le glissé et le retour ferment. -->
<vw-toast-popup [isOpen]="!!replyTarget" (close)="closeReply()" [ariaLabel]="replyTarget?.title ?? ''" [showClose]="false">
  @if (replyTarget) {
    <vw-advice-reply [target]="replyTarget" (reply)="onReply($event)"></vw-advice-reply>
  }
</vw-toast-popup>
@if (ending) {
  <vw-end-culture-toast [isOpen]="true" [plants]="ending.plants" (close)="ending = null" (ended)="onEnded()"></vw-end-culture-toast>
}
@if (picking) {
  <vw-harvest-log-toast [isOpen]="true" [plant]="picking.plant" (close)="picking = null" (logged)="onPicked()"></vw-harvest-log-toast>
}
@if (pendingUndo; as undo) {
  <vw-undo-snackbar [key]="undo.key" [message]="undoText" [durationMs]="undoMs" (undo)="onUndo($event)" (closed)="onUndoClosed($event)"></vw-undo-snackbar>
}
